export default __webpack_public_path__ + "static/media/ic_dollar.47d63e75.png";